__turbopack_context__.v({
  "dark": "md-page-module-scss-module__CD8ZUq__dark",
  "pages": "md-page-module-scss-module__CD8ZUq__pages",
});
